export default __webpack_public_path__ + "static/media/xelapan-logo-2019.9c8414a2.png";